var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGoogleLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 83.146,
    height: 26.149,
    viewBox: "0 0 83.146 26.149",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3749",
    "data-name": "Group 3749",
    transform: "translate(-9.958 -128.17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3110",
    "data-name": "Path 3110",
    d: "M20.342,137.486v2.8h6.688a5.929,5.929,0,0,1-1.525,3.526,6.844,6.844,0,0,1-5.164,2.047,7.439,7.439,0,0,1,0-14.878,7.112,7.112,0,0,1,5.039,2l1.967-1.967a9.659,9.659,0,0,0-7.006-2.844,10.238,10.238,0,1,0,0,20.473,9.384,9.384,0,0,0,7.143-2.866,9.26,9.26,0,0,0,2.422-6.541,8.98,8.98,0,0,0-.148-1.751Z",
    fill: "#346bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3111",
    "data-name": "Path 3111",
    d: "M42.837,147.306a4.014,4.014,0,1,1,3.731-4A3.822,3.822,0,0,1,42.837,147.306Zm0-10.612a6.609,6.609,0,1,0,6.631,6.608A6.512,6.512,0,0,0,42.837,136.694Z",
    transform: "translate(-4.569 -1.484)",
    fill: "#e12a26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3112",
    "data-name": "Path 3112",
    d: "M78.2,147.306c-2,0-3.526-1.706-3.526-4,0-2.332,1.524-4,3.526-4,1.979,0,3.526,1.706,3.526,4.026A3.679,3.679,0,0,1,78.2,147.306Zm3.333-9.133h-.1a4.58,4.58,0,0,0-3.48-1.479,6.624,6.624,0,0,0,0,13.217,4.513,4.513,0,0,0,3.48-1.5h.1v.921c0,2.526-1.354,3.879-3.526,3.879a3.664,3.664,0,0,1-3.333-2.354L72.154,151.9a6.293,6.293,0,0,0,5.858,3.9c3.4,0,6.279-2,6.279-6.881V137.035H81.537Z",
    transform: "translate(-10.761 -1.484)",
    fill: "#346bb3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3113",
    "data-name": "Path 3113",
    d: "M60.74,147.306a4.014,4.014,0,1,1,3.731-4A3.822,3.822,0,0,1,60.74,147.306Zm0-10.612a6.609,6.609,0,1,0,6.631,6.608A6.512,6.512,0,0,0,60.74,136.694Z",
    transform: "translate(-7.685 -1.484)",
    fill: "#fdab00"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2822",
    "data-name": "Rectangle 2822",
    width: 2.855,
    height: 19.985,
    transform: "translate(75.804 128.443)",
    fill: "#3d993d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3114",
    "data-name": "Path 3114",
    d: "M102.225,139.173a2.612,2.612,0,0,1,2.5,1.456L98.756,143.1A3.591,3.591,0,0,1,102.225,139.173Zm.2,8.133a3.364,3.364,0,0,1-3.208-2l8.837-3.651-.3-.751a6.136,6.136,0,0,0-5.653-4.209,6.28,6.28,0,0,0-6.233,6.608,6.461,6.461,0,0,0,6.552,6.609,6.591,6.591,0,0,0,5.5-2.924l-2.252-1.5A3.783,3.783,0,0,1,102.43,147.306Z",
    transform: "translate(-14.956 -1.484)",
    fill: "#e12a26"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleLogo);
export default __webpack_public_path__ + "static/media/googleLogo.a6f4000f.svg";
export { ForwardRef as ReactComponent };